import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  users: null,
  meta: null,
  isProcessFetching: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchUsers]: state => {
      return {
        ...state,
        isProcessFetching: true,
      }
    },
    [actions.fetchUsersSuccess]: (state, action) => {
      return {
        ...state,
        users: action.result.data,
        meta: action.result.meta,
        isProcessFetching: false,
      }
    },
    [actions.fetchUsersFailure]: (state, action) => {
      return {
        ...state,
        error: action.error,
        isProcessFetching: false,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
